import { Plus, Trash } from 'tabler-icons-react';
import { fileType, clx } from 'Utils';
import { ContentBox, Button, SubmitButton } from 'Elements';
import styles from 'partials/dashboard/add-story-box.module.scss';
import boxStyles from 'partials/dashboard/user-content.module.scss';

export const AddStoryBox = ({
	type,
	icon,
	onAdd,
	onSubmit,
	onRemove,
	...props
}) => {
	const handleAddStory = () => {
		onAdd?.(type);
	};

	const handleRemove = () => {
		onRemove?.(props.index, type);
	};

	return (
		<ContentBox
			title={fileType[type].title}
			icon={icon}
			headerButton={
				<Button
					className={clx(boxStyles.headerSubmit, styles.colorSubmit)}
					onClick={handleAddStory}>
					<Plus className={boxStyles.headerSubmitIcon} />{' '}
					{fileType[type].title} جدید
				</Button>
			}>
			<form onSubmit={onSubmit}>
				{props.children}
				<div className={styles.footer}>
					<Button className={styles.remove} onClick={handleRemove}>
						<Trash size="20" className={styles.submitIcon} />
						حذف
					</Button>
					<SubmitButton
						disabled={props.disabledSubmit}
						className={styles.submit}
						title={`ثبت ${fileType[type].title}`}
					/>
				</div>
			</form>
		</ContentBox>
	);
};
